import { Link } from 'react-router'
import { ArrowLeft, Briefcase, Users, Rocket, Heart } from 'lucide-react'
import { Button } from '#app/components/ui/button'

export default function CareersPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/50">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4" />
          Terug naar home
        </Link>

        <div className="space-y-12">
          <div className="text-center space-y-4">
            <Briefcase className="h-16 w-16 mx-auto text-primary" />
            <h1 className="text-4xl font-bold">Werken bij Woonplan</h1>
            <p className="text-xl text-muted-foreground">
              Help mee om renoveren toegankelijk te maken voor iedereen
            </p>
          </div>

          <div className="bg-card rounded-lg p-8 shadow-sm">
            <h2 className="text-2xl font-semibold mb-4">Onze Missie</h2>
            <p className="text-muted-foreground mb-6">
              Bij Woonplan geloven we dat iedereen het recht heeft op een comfortabel en duurzaam thuis.
              We bouwen aan de toekomst van renovatie met AI-gedreven tools die het proces eenvoudiger,
              transparanter en toegankelijker maken.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mt-8">
              <div className="text-center space-y-2">
                <Users className="h-10 w-10 mx-auto text-primary" />
                <h3 className="font-semibold">Teamwork</h3>
                <p className="text-sm text-muted-foreground">Samen bouwen aan innovatie</p>
              </div>
              <div className="text-center space-y-2">
                <Rocket className="h-10 w-10 mx-auto text-primary" />
                <h3 className="font-semibold">Groei</h3>
                <p className="text-sm text-muted-foreground">Persoonlijke ontwikkeling centraal</p>
              </div>
              <div className="text-center space-y-2">
                <Heart className="h-10 w-10 mx-auto text-primary" />
                <h3 className="font-semibold">Impact</h3>
                <p className="text-sm text-muted-foreground">Verschil maken voor huiseigenaren</p>
              </div>
            </div>
          </div>

          <div className="bg-muted/50 rounded-lg p-8">
            <h2 className="text-2xl font-semibold mb-4">Geen vacatures beschikbaar</h2>
            <p className="text-muted-foreground mb-6">
              Op dit moment hebben we geen openstaande vacatures, maar we zijn altijd op zoek naar getalenteerde mensen.
              Stuur ons je CV en motivatie, en we nemen contact met je op zodra er een passende rol beschikbaar komt.
            </p>
            <Button asChild>
              <a href="mailto:careers@woonplan.nl">Stuur open sollicitatie</a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}